import React, { useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

const ManageAdvertisement = () => {
  const [advertisements, setAdvertisements] = useState([]);
  const [userList, setUserList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const [advertisementID, setAdvertisementID] = useState("");

  const [userId, setUserId] = useState("");
  const [advertiseName, setAdvertiseName] = useState("");
  const [businessField, setBusinessField] = useState([]);
  const [logo, setLogo] = useState("");
  const [image, setImage] = useState("");
  const [majorLocality, setMajorLocality] = useState("");
  const [workExp, setWorkExp] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef();

  const userRole = localStorage.getItem("role");
  const userCity = localStorage.getItem("city");
  const loggedUserID = localStorage.getItem("uid");

  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");

  const [amount, setAmount] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [date, setDate] = useState("");
  const [remarks, setRemarks] = useState("");

  const navigate = useNavigate();

  const fetchAdvertisements = async () => {
    try {
      const res = await HomeService.getAdvertisements(); // API call
      console.log("DR49", res.data);
      if (res?.status) {
        if (userCity) {
          setAdvertisements(
            res.data
              .filter((item) => item?.city[0]._id === userCity)
              .sort((d1, d2) => new Date(d2.date) - new Date(d1.date)) || []
          );
        } else {
          setAdvertisements(
            res.data.sort((d1, d2) => new Date(d2.date) - new Date(d1.date)) ||
              []
          );
        }
      } else {
        toast.error("Failed to fetch advertisements.");
      }
    } catch (error) {
      toast.error("Error fetching advertisements.");
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchUsersAndCities = async () => {
    try {
      const [usersRes, citiesRes] = await Promise.all([
        HomeService.getUsers(),
        HomeService.getCities(),
      ]);
      setUserList(usersRes?.data || []);
      setCityList(citiesRes?.data || []);
    } catch (error) {
      console.error("Error fetching users or cities:", error);
    }
  };

  const toggleStatus = async (id, currentStatus) => {
    try {
      const newStatus = !currentStatus;
      await HomeService.updateAdvertisementStatus(id, { status: newStatus });
      fetchAdvertisements();
      toast.success("Advertisement status updated!");
    } catch (error) {
      toast.error("Failed to update status.");
      console.error("Error updating status:", error);
    }
  };

  const handleEdit = (row) => {
    console.log("UYT84", row);

    setIsEdit(true);
    setAdvertisementID(row._id);
    setUserId(row.user._id || "");
    setAdvertiseName(row.advertiseName || "");
    setBusinessField(row.businessField?.map((field) => field._id) || []);
    setLogo(row.logo || "");
    setImage(row.image || "");
    setMajorLocality(row.majorLocality || "");
    setWorkExp(row.workExp || "");
    setAmount(row?.amount);
    setStartDate(row?.startDate?.split("T")[0]);
    setEndDate(row?.endDate?.split("T")[0]);
    setDate(row?.date?.split("T")[0]);
    setRemarks(row?.remarks);
    setSelectedCity(row?.businessField[0]);

    const editSection = document.getElementById("edit-section");
    if (editSection) {
      editSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        id: advertisementID,
        userId,
        advertiseName,
        businessField,
        logo,
        image,
        majorLocality,
        workExp,
        remarks,
        amount,
        date,
        startDate,
        endDate,
      };
      console.log("submitted Data", payload);

      const res = await HomeService.updateAdvertisement(payload);
      if (res?.status) {
        toast.success("Advertisement updated successfully!");
        setIsEdit(false);
        fetchAdvertisements();
      }
    } catch (error) {
      toast.error("Failed to update advertisement.");
      console.error("Error:", error);
    }
  };

  const handleFileUpload = (e, type) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      if (type === "logo") {
        setLogo(reader.result);
      } else if (type === "image") {
        setImage(reader.result);
      }
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleCityChange = (e) => {
    const cityId = e.target.value;
    const isChecked = e.target.checked;
    setBusinessField((prev) =>
      isChecked ? [...prev, cityId] : prev.filter((id) => id !== cityId)
    );
  };

  const columns = [
    {
      name: "Date",
      selector: (row) => moment(row?.date?.split("T")[0]).format("DD-MM-YYYY"),
      sortable: true,
    },
    {
      name: "User",
      selector: (row) => row.user?.fullName || "N/A",
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => row.amount || "N/A",
      sortable: true,
    },
    {
      name: "Advertisement Name",
      selector: (row) => row.advertiseName || "N/A",
      sortable: true,
    },
    {
      name: "City",
      selector: (row) =>
        row.businessField?.map((field) => field.name).join(", ") || "N/A",
      sortable: true,
    },
    {
      name: "Major Locality",
      selector: (row) => row.majorLocality || "N/A",
      sortable: true,
    },
    {
      name: "Status",
      cell: (row) => (
        <button
          className={`btn btn-${row.status ? "success" : "danger"}`}
          onClick={() => toggleStatus(row._id, row.status)}
        >
          {row.status ? "Active" : "Inactive"}
        </button>
      ),
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <span title="Edit" onClick={() => handleEdit(row)}>
            <i
              className="fa-solid fa-pen-to-square"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "rgb(133, 218, 79)",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
          <span title="Delete" onClick={() => handleDelete(row._id)}>
            <i
              className="fa-solid fa-trash"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                //   color: " #477DA5",
                color: " red",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
        </>
      ),
    },
  ];

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Deleting Advertisement...",
      text: "Are you sure you want to delete this Advertisement ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "No, not sure!",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        const res = await HomeService.deleteAdvertisement(id);
        if (res?.status) {
          Swal.fire("Deleted!", "Advertisement has been deleted.", "success");
          fetchAdvertisements();
        }
      } catch (error) {
        Swal.fire("Error!", "Failed to delete Advertisement", "error");
      }
    }
  };

  // Fetch cities
  const fetchCities = async () => {
    try {
      const res = await HomeService.getCities();
      console.log("HYT31", res.data);

      if (res?.data) {
        setCities(res.data);
        if (userCity) {
          setCities([res.data.find((item) => item._id === userCity)]);
          setSelectedCity(userCity);
        } else {
          setCities(res.data);
        }
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  useEffect(() => {
    fetchAdvertisements();
    fetchUsersAndCities();
    fetchCities();
  }, []);

  return (
    <div className="main_wrap" style={{ marginTop: "6rem" }}>
      <div className="container-fluid">
        {isEdit ? (
          <section id="edit-section" className="chartBox_area">
            <h2>Edit Advertisement</h2>
            <hr />
            <form onSubmit={handleEditSubmit}>
              <div className="row">
                <div className="col-md-6 mt-3">
                  <label htmlFor="user">
                    User<span className="text-danger">*</span>
                  </label>
                  <select
                    id="user"
                    className="form-control"
                    value={userId}
                    onChange={(e) => setUserId(e.target.value)}
                    required
                  >
                    <option value="">Select User</option>
                    {userList.map((user) => (
                      <option key={user._id} value={user._id}>
                        {user.fullName} - {user.email}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="advertiseName">
                    Advertisement Name<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="advertiseName"
                    className="form-control"
                    value={advertiseName}
                    onChange={(e) => setAdvertiseName(e.target.value)}
                    required
                  />
                </div>

                <div className="col-md-6 mt-3">
                  {logo ? (
                    <>
                      <img
                        src={logo}
                        alt="Logo Preview"
                        style={{
                          display: "block",
                          marginTop: "10px",
                          maxHeight: "100px",
                          marginBottom: "1em",
                        }}
                      />
                    </>
                  ) : (
                    <label htmlFor="logo">
                      Upload Logo<span className="text-danger">*</span>
                    </label>
                  )}
                  <input
                    type="file"
                    name="logo"
                    id="logo"
                    className="form-control"
                    onChange={(e) => handleFileUpload(e, "logo")}
                    accept="image/*"
                    required={!logo}
                  />
                </div>

                <div className="col-md-6 mt-3">
                  {image ? (
                    <>
                      <img
                        src={image}
                        alt="Image Preview"
                        style={{
                          display: "block",
                          marginTop: "10px",
                          maxHeight: "100px",
                          marginBottom: "1em",
                        }}
                      />
                    </>
                  ) : (
                    <label htmlFor="image">
                      Upload Image<span className="text-danger">*</span>
                    </label>
                  )}
                  <input
                    type="file"
                    name="image"
                    id="image"
                    className="form-control"
                    onChange={(e) => handleFileUpload(e, "image")}
                    accept="image/*"
                    required={!image}
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="cities">
                    Cities<span className="text-danger">*</span>
                  </label>
                  {/* <div className="dropdown" ref={dropdownRef}>
                    <button
                      type="button"
                      className="form-control"
                      onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    >
                      {businessField.length === 0
                        ? "Select Cities"
                        : `${businessField.length} cities selected`}
                    </button>
                    {isDropdownOpen && (
                      <div className="dropdown-menu-for-city">
                        {cityList.map((city) => (
                          <div key={city._id} className="form-check">
                            <input
                              type="checkbox"
                              id={`city-${city._id}`}
                              value={city._id}
                              checked={businessField.includes(city._id)}
                              onChange={handleCityChange}
                              className="form-check-input"
                            />
                            <label
                              htmlFor={`city-${city._id}`}
                              className="form-check-label"
                            >
                              {city.name}
                            </label>
                          </div>
                        ))}
                      </div>
                    )}
                  </div> */}
                  <select
                    className="form-control"
                    value={selectedCity}
                    onChange={(e) => setSelectedCity(e.target.value)}
                  >
                    <option value="" disabled>
                      ---Select---
                    </option>
                    {cities.map((city, key) => (
                      <option key={key} value={city._id}>
                        {city.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="majorLocality">
                    Major Locality<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="majorLocality"
                    className="form-control"
                    value={majorLocality}
                    onChange={(e) => setMajorLocality(e.target.value)}
                    required
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="workExp">
                    Amount<span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    id="workExp"
                    className="form-control"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    required
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="workExp">
                    Work Experience (Years)
                    <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    id="workExp"
                    className="form-control"
                    value={workExp}
                    onChange={(e) => setWorkExp(e.target.value)}
                    required
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="startDate">
                    Start Date<span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    id="startDate"
                    className="form-control"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    required
                  />
                </div>
                <div className="col-md-6 mt-3">
                  <label htmlFor="endDate">
                    End Date<span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    id="endDate"
                    className="form-control"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="endDate">
                    Date<span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    id="date"
                    className="form-control"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="endDate">Remarks</label>
                  {/* <input
                    type="text"
                    id="endDate"
                    className="form-control"
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                  /> */}
                  <textarea
                    className="form-control"
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    placeholder="Enter remarks (if any)"
                  ></textarea>
                </div>
              </div>
              <button type="submit" className="btn btn-primary mt-3">
                Save Changes
              </button>
              <button
                type="button"
                className="btn btn-secondary mt-3"
                style={{ marginLeft: "11px" }}
                onClick={() => setIsEdit(false)}
              >
                Cancel
              </button>
            </form>
          </section>
        ) : (
          <>
            <div className="mt-5">
              <div style={headLineStyle}>Manage Advertisements</div>
              <hr />
              <button
                type="submit"
                style={{
                  background: "#fff",
                  border: "solid 2px #85da4f",
                  borderRadius: "13px",
                  margin: "10px",
                }}
                className="btn mt-3"
                onClick={() => {
                  navigate("/add-advertisement");
                }}
              >
                Add Advertisement
              </button>
              {loading ? (
                <p>Loading...</p>
              ) : (
                <section className="chartBox_area">
                  <DataTable
                    columns={columns}
                    data={advertisements}
                    pagination
                    highlightOnHover
                  />
                </section>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ManageAdvertisement;
